import Vue from 'vue'
import Router from 'vue-router'
import store from './store'
import http from "./axios"

Vue.use(Router);

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'base-name',
            redirect: (to) => {
                if (to && to.path && to.path === "/") {
                    return "/dashboard"
                }
            }
        },
        {
            path: '/category',
            name: 'category',
            component: () => import('./views/category/CategoryList'),
            meta: {
                permission: 'CATEGORY'
            }
        },
        {
            path: '/category/new',
            name: 'category-new',
            component: () => import('./views/category/CategoryEdit'),
            meta: {
                permission: 'CATEGORY',
                actionPermission: "CATEGORY_ADD"
            }
        },
        {
            path: '/category/edit/:id',
            name: 'category-edit',
            component: () => import('./views/category/CategoryEdit'),
            meta: {
                permission: 'CATEGORY',
                actionPermission: 'CATEGORY_EDIT'
            }
        },
        {
            path: '/category/view/:id',
            name: 'category-view',
            component: () => import('./views/category/CategoryView'),
            meta: {
                permission: 'CATEGORY',
                actionPermission: 'CATEGORY_VIEW'
            }
        },
        {
            path: '/product',
            name: 'product',
            component: () => import('./views/product/ProductList'),
            meta: {
                permission: 'PRODUCT'
            }
        },
        {
            path: '/product/new',
            name: 'product-new',
            component: () => import('./views/product/ProductEdit'),
            meta: {
                permission: 'PRODUCT',
                actionPermission: 'PRODUCT_ADD'
            }
        },
        {
            path: '/product/edit/:id',
            name: 'product-edit',
            component: () => import('./views/product/ProductEdit'),
            meta: {
                permission: 'PRODUCT',
                actionPermission: 'PRODUCT_EDIT'
            }
        },
        {
            path: '/product/view/:id',
            name: 'product-view',
            component: () => import('./views/product/ProductView'),
            meta: {
                permission: 'PRODUCT',
                actionPermission: 'PRODUCT_VIEW'
            }
        },
        {
            path: '/region',
            name: 'region',
            component: () => import('./views/region/RegionList'),
            meta: {
                permission: 'REGION'
            }
        },
        {
            path: '/region/new',
            name: 'region-new',
            component: () => import('./views/region/RegionEdit'),
            meta: {
                permission: 'REGION'
            }
        },
        {
            path: '/region/edit/:id',
            name: 'region-edit',
            component: () => import('./views/region/RegionEdit'),
            meta: {
                permission: 'REGION',
                actionPermission: 'REGION_EDIT'
            }
        },
        {
            path: '/region/view/:id',
            name: 'region-view',
            component: () => import('./views/region/RegionView'),
            meta: {
                permission: 'REGION',
                actionPermission: 'REGION_VIEW'
            }
        },
        {
            path: '/message',
            name: 'message',
            component: () => import('./views/message/MessageList'),
            meta: {
                permission: 'MESSAGE'
            }
        },
        {
            path: '/sms-code',
            name: 'sms-code',
            component: () => import('./views/sms-code/SmsCodeList'),
            meta: {
                permission: 'SMS_CODES'
            }
        },
        {
            path: '/user',
            name: 'user',
            component: () => import('./views/user/UserList'),
            meta: {
                permission: 'USER'
            }
        },
        {
            path: '/map',
            name: 'map',
            component: () => import('./views/map/MapPolygon'),
            meta: {
                permission: 'MAP'
            }
        },
        {
            path: '/building-type',
            name: 'building-type',
            component: () => import('./views/building-type/Settings.vue'),
            meta: {
                permission: 'BUILDING_TYPE'
            }
        },
        {
            path: '/building-type/list',
            name: 'building-type',
            component: () => import('./views/building-type/BuildingTypeList'),
            meta: {
                permission: 'BUILDING_TYPE'
            }
        },
        {
            path: '/branch/list',
            name: 'branch',
            component: () => import('./views/building-type/BranchList.vue'),
            meta: {
                permission: 'BUILDING_TYPE'
            }
        },
        {
            path: '/dashboard',
            name: 'dashboard',
            component: () => import('./views/dashboard/index')
        },
        {
            path: '/settings',
            name: 'settings',
            component: () => import('./views/settings/Settings'),
            meta: {
                permission: 'SETTINGS'
            }
        },
        {
            path: '/settings/area-analysis/new',
            name: 'settings-area-analysis-new',
            component: () => import('./views/settings/area-analysis/AreaAnalysisEdit'),
            meta: {
                permission: 'SETTINGS'
            }
        },
        {
            path: '/settings/area-analysis/new/object',
            name: 'settings-area-analysis-new-object',
            component: () => import('./views/settings/area-analysis/object/ObjectEdit'),
            meta: {
                permission: 'SETTINGS'
            }
        },
        {
            path: '/settings/area-analysis/new/object/edit/:objectId',
            name: 'settings-area-analysis-new-object-edit',
            component: () => import('./views/settings/area-analysis/object/ObjectEdit'),
            meta: {
                permission: 'SETTINGS'
            }
        },
        {
            path: '/settings/area-analysis/edit/:id',
            name: 'settings-area-analysis-edit',
            component: () => import('./views/settings/area-analysis/AreaAnalysisEdit'),
            meta: {
                permission: 'SETTINGS'
            }
        },
        {
            path: '/settings/area-analysis/edit/:objectId/object',
            name: 'settings-area-analysis-edit-object',
            component: () => import('./views/settings/area-analysis/object/ObjectEdit'),
            meta: {
                permission: 'SETTINGS'
            }
        },
        {
            path: '/settings/area-analysis/edit/:id/object/edit/:objectId',
            name: 'settings-area-analysis-edit-object-edit',
            component: () => import('./views/settings/area-analysis/object/ObjectEdit'),
            meta: {
                permission: 'SETTINGS'
            }
        },
        {
            path: '/settings/clients/new',
            name: 'settings-clients-new',
            component: () => import('./views/settings/clients/ClientsEdit'),
            meta: {
                permission: 'SETTINGS'
            }
        },
        {
            path: '/settings/clients/edit/:id',
            name: 'settings-clients-edit',
            component: () => import('./views/settings/clients/ClientsEdit'),
            meta: {
                permission: 'SETTINGS'
            }
        },
        {
            path: '/settings/crm/new',
            name: 'settings-crm-new',
            component: () => import('./views/settings/crm/CRMEdit'),
            meta: {
                permission: 'SETTINGS'
            }
        },
        {
            path: '/settings/crm/edit/:id',
            name: 'settings-crm-edit',
            component: () => import('./views/settings/crm/CRMEdit'),
            meta: {
                permission: 'SETTINGS'
            }
        },
        {
            path: '/settings/object-compatibility/new',
            name: 'settings-object-compatibility-new',
            component: () => import('./views/settings/object-compatibility/ObjectCompatibilityEdit.vue'),
            meta: {
                permission: 'SETTINGS'
            }
        },
        {
            path: '/settings/object-compatibility/edit/:id',
            name: 'settings-object-compatibility-edit',
            component: () => import('./views/settings/object-compatibility/ObjectCompatibilityEdit.vue'),
            meta: {
                permission: 'SETTINGS'
            }
        },
        {
            path: '/settings/standard-indicator/new',
            name: 'settings-standard-indicator-new',
            component: () => import('./views/settings/object-compatibility/StandardIndicatorEdit.vue'),
            meta: {
                permission: 'SETTINGS'
            }
        },
        {
            path: '/settings/standard-indicator/edit/:id',
            name: 'settings-standard-indicator-edit',
            component: () => import('./views/settings/object-compatibility/StandardIndicatorEdit.vue'),
            meta: {
                permission: 'SETTINGS'
            }
        },
        {
            path: '/settings/faq',
            name: 'faq',
            component: () => import('@/views/settings/faq/FaqList.vue'),
        },
        {
            path: '/settings/faq/add',
            name: 'faq-add',
            component: () => import('@/views/settings/faq/FaqAdd.vue'),
        },
        {
            path: '/settings/faq/edit/:id',
            name: 'buyer-edit',
            component: () => import('@/views/settings/faq/FaqEdit.vue'),
        },
        {
            path: '/notifications',
            name: 'notifications',
            component: () => import('./views/notifications/index')
        },
        {
            path: '/contacts',
            name: 'contacts',
            component: () => import('./views/contacts/index')
        },
        {
            path: '/sale',
            name: 'sale',
            component: () => import('@/views/sale/SaleList'),
            meta: {
                permission: 'SALE'
            }
        },
        {
            path: '/sale/edit/:id',
            name: 'sale-edit',
            component: () => import('@/views/sale/SaleEdit'),
            meta: {
                permission: 'SALE',
                actionPermission: 'SALE_EDIT'
            }
        },
        {
            path: '/order',
            name: 'order',
            component: () => import('./views/order/OrderList'),
            meta: {
                permission: 'ORDER'
            }
        },
        {
            path: '/order/:id',
            name: 'order-edit',
            component: () => import('./views/order/OrderEdit'),
            meta: {
                permission: 'ORDER',
                actionPermission: 'ORDER_EDIT'
            }
        },
        {
            path: '/objects-analysis',
            name: 'objects-analysis',
            component: () => import('@/views/objects-analysis/ObjectsAnalysisList'),
            meta: {
                permission: 'OBJECTS_ANALYSIS',
                allowFullPathRedirect: true
            }
        },
        {
            path: '/objects-analysis/edit/:id',
            name: 'objects-analysis-edit',
            component: () => import('@/views/objects-analysis/ObjectsAnalysisEdit'),
            meta: {
                permission: 'OBJECTS_ANALYSIS',
                actionPermission: 'OBJECTS_ANALYSIS_EDIT'
            }
        },
        {
            path: '/buyer-list',
            name: 'buyer-list',
            component: () => import('@/views/buyer/BuyerList.vue'),
            meta: {
                permission: 'BUYER'
            }
        },
        {
            path: '/buyer/add',
            name: 'buyer-add',
            component: () => import('@/views/buyer/BuyerAdd.vue'),
            meta: {
                permission: 'BUYER',
                actionPermission: 'BUYER_ADD'
            }
        },
        {
            path: '/buyer/edit/:id',
            name: 'buyer-edit',
            component: () => import('@/views/buyer/BuyerEdit.vue'),
            meta: {
                permission: 'BUYER',
                actionPermission: 'BUYER_EDIT'
            }
        },
        {
            path: '/publish-to-advertisement',
            name: 'publish-to-advertisement',
            component: () => import('@/views/publish-to-advertisement/PublishToAdvertisementList.vue'),
            meta: {
                permission: 'PUBLISH_TO_ADVERTISEMENT'
            }
        },
        {
            path: '/realtor-assistants',
            name: 'realtor-assistants',
            component: () => import('@/views/realtor-assistant/RealtorAssistantList.vue'),
            meta: {
                permission: 'LIST_OF_REALTORS'
            }
        },
        {
            path: '/micro-region/edit',
            name: 'micro-region-edit',
            component: () => import('./views/settings/mfy-microregion/MicroRegionEdit'),
            meta: {
                permission: 'REGION'
            }
        },
        {
            path: '/telegram/add-edit',
            name: 'telegram-edit',
            component: () => import('./views/settings/telegram/TelegramAddEdit'),
            meta: {
                permission: 'TELEGRAM'
            }
        },
        {
            path: '/users-sign-policy-contracts',
            name: 'users-sign-policy-contracts',
            component: () => import('@/views/user-sign-policy-contract/UserSignPolicyContractList.vue'),
            meta: {
                permission: 'SIGN_USER_POLICY_CONTRACT'
            }
        },
        {
            path: '/check-sign',
            name: 'check-sign',
            component: () => import('./views/check-sign/index')
        }
    ]
})

router.beforeEach((to, from, next) => {

    if (to.path.split("/")[1] !== from.path.split("/")[1]) {
        store.dispatch("deleteFiltersData")
    }

    if (to.meta.permission && (to.meta?.permission !== from.meta?.permission || to.meta?.actionPermission !== from.meta?.actionPermission)) {
        http.post('permission/user/actions', {code: to.meta.permission})
            .then(res => {
                store.dispatch('setPermission', res.data)
                if (store.state.menus.length > 0) {
                    if (store.state.menus.indexOf(to.meta.permission) >= 0) {
                        to.meta.actionPermission
                            ? res.data.includes(to.meta.actionPermission)
                                ? next()
                                : next(to.meta?.allowFullPathRedirect ? to.fullPath.split("/")[1] : to.path.split("/")[1])
                            : next()
                    } else {
                        next("/dashboard")
                    }
                } else {
                    http.get('/permission/user/menu')
                        .then(menuRes => {
                            if (menuRes && menuRes.data && menuRes.data.menus) {
                                store.dispatch("setMenus", menuRes.data.menus)
                                if (store.state.menus.indexOf(to.meta.permission) >= 0) {
                                    if (to.meta.actionPermission && res.data.includes(to.meta.actionPermission)) {
                                        next()
                                    } else {
                                        next(to.meta?.allowFullPathRedirect ? to.fullPath.split("/")[1] : to.path.split("/")[1])
                                    }
                                } else {
                                    next("/dashboard")
                                }
                            }
                        }).catch((err) => {
                        console.error(err);
                        next("/dashboard")
                    });
                }

            }).catch((err) => {
            console.error(err);
            next("/dashboard")
        })
    } else {
        next()
    }

    return next;
});

export default router;